import { Button, Divider, Flex, Spin, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import ActionConfirmationModal from 'src/app/shared/components/modal/action-confirmation-modal'
import { DangerBintIcon } from 'src/assets/icons'
import { LoadingOutlined } from '@ant-design/icons'
import RichTextField from 'src/app/shared/components/common/rich-text-field'
import { colorBgErrorBold, colorBorderDisabled } from 'src/app/themes/primaryThemeDefault'
import '../index.scss'

interface IProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isLoading?: boolean
  fileName?: string
  data: any
  isPurging: boolean
}

const DeleteTransactionsModal = (props: IProps) => {
  const { isOpen, isPurging, onClose, onConfirm, isLoading = false, fileName = '', data } = props
  const { t } = useTranslation()

  return (
    <ActionConfirmationModal
      icon={<DangerBintIcon />}
      title={<Typography className='modal-title'>{t('PurgeTransactions:popUp.deleteTransactions.title')}</Typography>}
      onClose={onClose}
      isOpen={isOpen}
      descriptionType='string'
      description={
        <Flex vertical align='center' justify='center' className='delete-transaction'>
          <span style={{ textAlign: 'center', paddingBottom: 24 }}>
            <RichTextField richText={t('PurgeTransactions:popUp.deleteTransactions.message', { fileName })} />
          </span>
          <Flex
            align='flex-start'
            justify='space-between'
            style={{
              border: `1px solid ${colorBorderDisabled}`,
              padding: '12px 0px',
              borderRadius: '16px',
              width: 400,
            }}
            vertical
          >
            <Typography.Text style={{ paddingLeft: '15px', fontWeight: 700 }}>
              {t('PurgeTransactions:popUp.deleteTransactions.recordToDelete')}
            </Typography.Text>
            <Divider style={{ margin: '12px 0px 8px' }} />
            <Flex style={{ padding: '0px 15px', width: '100%' }} align='center' justify='space-between'>
              <Typography.Text>{t('PurgeTransactions:popUp.deleteTransactions.numberOfTransactions')}</Typography.Text>
              <Typography.Text strong>{data?.numberOfRecordsToDelete || 0}</Typography.Text>
            </Flex>
            <Flex style={{ padding: '0px 15px', width: '100%' }} align='center' justify='space-between'>
              <Typography.Text>{t('PurgeTransactions:popUp.deleteTransactions.totalAmount')}</Typography.Text>
              <Typography.Text strong>{data?.totalAmount || 0}</Typography.Text>
            </Flex>
          </Flex>
        </Flex>
      }
      footer={[
        <Button size='middle' type='primary' onClick={onClose} key={'cancel'}>
          {isLoading ? (
            <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    color: 'white',
                  }}
                />
              }
            />
          ) : (
            t('PurgeTransactions:popUp.button.cancel')
          )}
        </Button>,
        <Button
          size='middle'
          onClick={onConfirm}
          key={'delete'}
          style={{ border: `1px solid ${colorBgErrorBold}`, color: colorBgErrorBold }}
          disabled={isPurging}
          loading={isPurging}
        >
          {t('PurgeTransactions:popUp.button.delete')}
        </Button>,
      ]}
    />
  )
}

export default DeleteTransactionsModal
